import React from "react";
import "./styles/EnergyStep.scss";
import BannerType1 from "./BannerType1";
import { useTranslation } from "react-i18next";
const EnergyStep = () => {
  const { t } = useTranslation();
  const contents = t("it.netZero.energyStep.contents", { returnObjects: true }) as { name: string; des: string }[];
  return (
    <>
      <div className="energy_step_wrap">
        <BannerType1 path="/imgs/banner_netzero_overview.png" />
        <h2 className="title">{t("it.netZero.energyStep.title")}</h2>
        <div className="contents">
          {contents.map((content: { name: string; des: string }, index: number) => {
            return (
              <div className="content" key={`${content.name}_${index}`}>
                <div className="left">
                  <div className="img_box">
                    <img src="/imgs/step_circle.png" alt="circle" />
                  </div>
                  <span>Step {index + 1}</span>
                </div>
                <div className="right">
                  <div className="name">{content.name}</div>
                  <div className="des">{content.des}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default EnergyStep;
